import { render, staticRenderFns } from "./wareConfig.vue?vue&type=template&id=23ff371f&"
import script from "./wareConfig.vue?vue&type=script&lang=js&"
export * from "./wareConfig.vue?vue&type=script&lang=js&"
import style0 from "./wareConfig.vue?vue&type=style&index=0&id=23ff371f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports